import { render } from "./CurrentMed.vue?vue&type=template&id=1c2f0af0&scoped=true"
import script from "./CurrentMed.vue?vue&type=script&lang=js"
export * from "./CurrentMed.vue?vue&type=script&lang=js"

import "./CurrentMed.vue?vue&type=style&index=0&id=1c2f0af0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2f0af0"]])

export default __exports__